import { render } from "./RegistrarFacultyCourseLoad.vue?vue&type=template&id=6f1f41cc"
import script from "./RegistrarFacultyCourseLoad.vue?vue&type=script&lang=js"
export * from "./RegistrarFacultyCourseLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__